import React, { useState, useRef } from 'react';
import { useSources } from 'hooks';
import { IconButton } from '@material-ui/core';
import { MdDownload } from 'react-icons/md';
import { CSVLink } from 'react-csv';
import _ from 'lodash';

import { formatDate } from 'utils/time';
import API from 'utils/api';

import { Table, Tooltip } from 'components';

const AgencyWaitList = props => {
  const [dataReport, setDataReport] = useState([]);
  const [csvLink, setCsvLink] = useState();
  const tableRef = useRef();

  const sources = useSources();

  const { dateFrom, dateTo } = props;

  const columns = [
    {
      title: 'User',
      field: 'name',
      filtering: false,
      render: rowData => {
        let name = 'Anonymous user';

        if (rowData.type === 'waitlist') {
          const waitListStaus = _.get(rowData, 'waitlist.status', null);
          const phone = _.get(rowData, 'waitlist.phoneNumber', null);
          name = waitListStaus === 'confirmed' ? phone : null;
        }

        if (rowData.name) {
          name = rowData.name;
        }

        return <div>{name}</div>;
      },
    },
    {
      title: 'Referral from',
      field: 'waitlist.referralCode',
    },
    {
      title: 'Engagement',
      field: 'engagement',
      filtering: false,
    },
    {
      title: 'Subscribed',
      field: 'createdAt',
      render: rowData => <div>{formatDate(rowData.createdAt)}</div>,
      type: 'date',
      filtering: false,
    },
  ];

  const renderControlPanel = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <IconButton onClick={exportCSV}>
          <Tooltip title="Click to export table data" placement="top">
            <MdDownload />
          </Tooltip>
        </IconButton>
      </div>
    );
  };

  const exportCSV = () => {
    let query = {};

    const search = _.get(tableRef, 'current.state.search', '');
    const filter = _.get(tableRef, 'current.state.filter', {});

    if (search.length > 0) {
      query.name = search;
    }

    if (filter) {
      for (const keyFilter in filter) {
        query[keyFilter] = filter[keyFilter];
      }
    }

    API.getUserInteractions(
      {
        ...query,
        type: 'waitlist',
      },
      sources
    ).then(({ data }) => {
      if (data && data.docs) {
        const users = data.docs.map(user => {
          let name = 'Anonymous user';

          if (user.type === 'waitlist') {
            const waitListStatus = _.get(user, 'waitlist.status', null);
            const phone = _.get(user, 'waitlist.phoneNumber', null);
            name = waitListStatus === 'confirmed' ? phone : null;
          }

          if (user.name) {
            name = user.name;
          }

          return {
            user: name,
            referral: user.waitlist.referralCode,
            engagement: user.engagement,
            subscribed: user.createdAt,
          };
        });
        setDataReport(users);
        csvLink.link.click();
      }
    });
  };

  const fetchData = ({ pageSize, page, search, sort, filter }) => {
    let query = {};

    if (filter) {
      for (const keyFilter in filter) {
        query[keyFilter] = filter[keyFilter];
      }
    }

    if (search && search.length > 0) {
      query.name = search;
    }

    return API.getUserInteractions(
      {
        type: 'waitlist',
        ...query,
        per_page: pageSize,
        page,
        from: dateFrom,
        to: dateTo,
        sort: sort ? sort : 'createdAt',
      },
      sources
    );
  };

  return (
    <>
      <CSVLink
        data={dataReport}
        filename="data.csv"
        className="hidden"
        ref={r => setCsvLink(r)}
        target="_blank"
      />

      <Table
        title="Users"
        columns={columns}
        data={fetchData}
        tableRef={tableRef}
        controlPanel={renderControlPanel()}
        filtering
      />
    </>
  );
};

export default AgencyWaitList;
